//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthClient } from '../app/services/authService';
import { getAccessToken } from 'app/utils/authUtilities';
export class SdsgApiClientBase {
    constructor() { };

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (options.headers) {
            let token = getAccessToken();
            if(token === null) {
                token = await new AuthClient().getToken();
            }
            var headers = options.headers as { [index: string]: string };
            headers['Authorization'] = `Bearer ${token}`;
        }
        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processResponse: (_response: Response) => Promise<any>
    ): Promise<any> {
        try {
            return await processResponse(response);
        } catch (error: any) {
            if(response.ok) {
                return;
            }

            throw new ApiError(
                response.status,
                response.statusText,
                error?.result ?? error
            );
        }
    }
}

export class SdsgApiClient extends SdsgApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    home_Index(): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Home";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome_Index(_response));
        });
    }

    protected processHome_Index(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get list of SDSG Case Types
     * @return List of SDSG Case Types with ID and Name
     */
    lookup_SDSGCaseType(): Promise<EnumLookUp[]> {
        let url_ = this.baseUrl + "/sdsg/Lookup/CustomerRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookup_SDSGCaseType(_response));
        });
    }

    protected processLookup_SDSGCaseType(response: Response): Promise<EnumLookUp[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumLookUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumLookUp[]>(null as any);
    }

    /**
     * Create a Proposal
     * @return Returns the newly created proposal id
     */
    proposal_CreateProposal(createProposalRequest: CreateProposalDto): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Proposal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createProposalRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_CreateProposal(_response));
        });
    }

    protected processProposal_CreateProposal(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update a proposal
     * @return Returns the updated proposal object
     */
    proposal_UpdateProposal(editProposalRequest: EditProposalDto): Promise<ProposalDto> {
        let url_ = this.baseUrl + "/sdsg/Proposal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editProposalRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_UpdateProposal(_response));
        });
    }

    protected processProposal_UpdateProposal(response: Response): Promise<ProposalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ProposalID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalDto>(null as any);
    }

    /**
     * Get proposals with pagination
     * @param pageNumber (optional) The page number
     * @param pageSize (optional) Page size
     */
    proposal_Proposals(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfProposalDto> {
        let url_ = this.baseUrl + "/sdsg/Proposal?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_Proposals(_response));
        });
    }

    protected processProposal_Proposals(response: Response): Promise<PaginatedListOfProposalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProposalDto>(null as any);
    }

    /**
     * Deletes the Proposal
     * @param requestId (optional) The Proposal Id
     * @param suppressNotification (optional) To propogate events or not
     */
    proposal_Delete(requestId: string | null | undefined, suppressNotification: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Proposal?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (suppressNotification !== undefined && suppressNotification !== null)
            url_ += "suppressNotification=" + encodeURIComponent("" + suppressNotification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_Delete(_response));
        });
    }

    protected processProposal_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the Proposal
     * @param requestId The Guid
     * @return Returns the proposal object
     */
    proposal_GetProposalById(requestId: string): Promise<ProposalDto> {
        let url_ = this.baseUrl + "/sdsg/Proposal/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_GetProposalById(_response));
        });
    }

    protected processProposal_GetProposalById(response: Response): Promise<ProposalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the ProposalID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalDto>(null as any);
    }

    proposal_DeleteCustomerImpact(id: string, customerImpact: CustomerImpactDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Proposal/{id}/DeleteCustomerImpact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_DeleteCustomerImpact(_response));
        });
    }

    protected processProposal_DeleteCustomerImpact(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Assign user to the request
     * @return True on success
     */
    proposal_Assign(assignRequestDto: AssignRequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_Assign(_response));
        });
    }

    protected processProposal_Assign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reassign the Request
     */
    proposal_Reassign(reassignDto: RequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reassignDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_Reassign(_response));
        });
    }

    protected processProposal_Reassign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    proposal_AddAttachments(addAttachmentDto: AddAttachmentDto): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addAttachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_AddAttachments(_response));
        });
    }

    protected processProposal_AddAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    proposal_DeleteAttachmentById(id: string, entityId: string | null | undefined, entityType: EntityType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Attachment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_DeleteAttachmentById(_response));
        });
    }

    protected processProposal_DeleteAttachmentById(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    proposal_GetAttachments(entityId: string | null | undefined, entityType: EntityType | undefined, portal: Portal | undefined): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Attachment/List?";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (portal === null)
            throw new Error("The parameter 'portal' cannot be null.");
        else if (portal !== undefined)
            url_ += "portal=" + encodeURIComponent("" + portal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_GetAttachments(_response));
        });
    }

    protected processProposal_GetAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    proposal_UpdateParentChild(requestDto: RequestDto): Promise<RequestDto> {
        let url_ = this.baseUrl + "/sdsg/Proposal/ParentChild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_UpdateParentChild(_response));
        });
    }

    protected processProposal_UpdateParentChild(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    proposal_UpdateDevices(requestDto: RequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_UpdateDevices(_response));
        });
    }

    protected processProposal_UpdateDevices(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add Hash Tags
     * @param id SKP-ID
     * @param hashTags HashTags
     */
    proposal_AddHashTags(id: string, hashTags: HashTagDto[]): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Proposal/{id}/AddHashTags";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hashTags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_AddHashTags(_response));
        });
    }

    protected processProposal_AddHashTags(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    proposal_AddCustomerImpact(addCustomerImpact: AddCustomerImpactDto): Promise<CustomerImpactResponseDto> {
        let url_ = this.baseUrl + "/sdsg/Proposal/AddCustomerImpact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addCustomerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_AddCustomerImpact(_response));
        });
    }

    protected processProposal_AddCustomerImpact(response: Response): Promise<CustomerImpactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactResponseDto>(null as any);
    }

    proposal_UpdateWatcher(addWatcherDto: AddWatcherDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Proposal/Watcher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addWatcherDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProposal_UpdateWatcher(_response));
        });
    }

    protected processProposal_UpdateWatcher(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Create a Question
     * @return Returns the newly created Question id
     */
    question_CreateQuestion(createQuestionRequest: CreateQuestionDto): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Question";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createQuestionRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_CreateQuestion(_response));
        });
    }

    protected processQuestion_CreateQuestion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update the Question
     */
    question_UpdateQuestion(editQuestionRequest: EditQuestionDto): Promise<QuestionDto> {
        let url_ = this.baseUrl + "/sdsg/Question";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editQuestionRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_UpdateQuestion(_response));
        });
    }

    protected processQuestion_UpdateQuestion(response: Response): Promise<QuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the QuestionID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDto>(null as any);
    }

    /**
     * Delete the Question
     * @param requestId (optional) The Question id
     * @param suppressNotification (optional) To propogate events or not
     */
    question_Delete(requestId: string | null | undefined, suppressNotification: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Question?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (suppressNotification !== undefined && suppressNotification !== null)
            url_ += "suppressNotification=" + encodeURIComponent("" + suppressNotification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_Delete(_response));
        });
    }

    protected processQuestion_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Question with pagination
     * @param pageNumber (optional) The page number
     * @param pageSize (optional) Page size
     */
    question_GetQuestionWithPagination(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfQuestionDto> {
        let url_ = this.baseUrl + "/sdsg/Question?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_GetQuestionWithPagination(_response));
        });
    }

    protected processQuestion_GetQuestionWithPagination(response: Response): Promise<PaginatedListOfQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionDto>(null as any);
    }

    /**
     * Get the Question by Id
     * @param questionId The Guid
     * @return Returns the Question objec
     */
    question_GetQuestionById(questionId: string): Promise<QuestionDto> {
        let url_ = this.baseUrl + "/sdsg/Question/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_GetQuestionById(_response));
        });
    }

    protected processQuestion_GetQuestionById(response: Response): Promise<QuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the QuestionID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDto>(null as any);
    }

    question_DeleteCustomerImpact(id: string, customerImpact: CustomerImpactDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Question/{id}/DeleteCustomerImpact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_DeleteCustomerImpact(_response));
        });
    }

    protected processQuestion_DeleteCustomerImpact(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Assign user to the request
     * @return True on success
     */
    question_Assign(assignRequestDto: AssignRequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Question/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_Assign(_response));
        });
    }

    protected processQuestion_Assign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reassign the Request
     */
    question_Reassign(reassignDto: RequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Question/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reassignDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_Reassign(_response));
        });
    }

    protected processQuestion_Reassign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    question_AddAttachments(addAttachmentDto: AddAttachmentDto): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/sdsg/Question/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addAttachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_AddAttachments(_response));
        });
    }

    protected processQuestion_AddAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    question_DeleteAttachmentById(id: string, entityId: string | null | undefined, entityType: EntityType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Question/Attachment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_DeleteAttachmentById(_response));
        });
    }

    protected processQuestion_DeleteAttachmentById(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    question_GetAttachments(entityId: string | null | undefined, entityType: EntityType | undefined, portal: Portal | undefined): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/sdsg/Question/Attachment/List?";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (portal === null)
            throw new Error("The parameter 'portal' cannot be null.");
        else if (portal !== undefined)
            url_ += "portal=" + encodeURIComponent("" + portal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_GetAttachments(_response));
        });
    }

    protected processQuestion_GetAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    /**
     * Update the classification of an attachment
     */
    question_UpdateClassification(attachmentDto: UpdateClassificationDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Question/Attachment/UpdateClassification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_UpdateClassification(_response));
        });
    }

    protected processQuestion_UpdateClassification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    question_UpdateParentChild(requestDto: RequestDto): Promise<RequestDto> {
        let url_ = this.baseUrl + "/sdsg/Question/ParentChild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_UpdateParentChild(_response));
        });
    }

    protected processQuestion_UpdateParentChild(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    question_UpdateDevices(requestDto: RequestDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Question/Devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_UpdateDevices(_response));
        });
    }

    protected processQuestion_UpdateDevices(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Add Hash Tags
     * @param id SKP-ID
     * @param hashTags HashTags
     */
    question_AddHashTags(id: string, hashTags: HashTagDto[]): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Question/{id}/AddHashTags";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hashTags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_AddHashTags(_response));
        });
    }

    protected processQuestion_AddHashTags(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    question_AddCustomerImpact(addCustomerImpact: AddCustomerImpactDto): Promise<CustomerImpactResponseDto> {
        let url_ = this.baseUrl + "/sdsg/Question/AddCustomerImpact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addCustomerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_AddCustomerImpact(_response));
        });
    }

    protected processQuestion_AddCustomerImpact(response: Response): Promise<CustomerImpactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactResponseDto>(null as any);
    }

    question_UpdateWatcher(addWatcherDto: AddWatcherDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Question/Watcher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addWatcherDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuestion_UpdateWatcher(_response));
        });
    }

    protected processQuestion_UpdateWatcher(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Create a Rfx
     * @return Returns the newly created rfx id
     */
    rfx_CreateRfx(createRfxRequest: CreateRfxDto): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Rfx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRfxRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_CreateRfx(_response));
        });
    }

    protected processRfx_CreateRfx(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update a Rfx
     * @return Returns the updated rfx object
     */
    rfx_UpdateRfx(editRfxRequest: EditRfxDto): Promise<RfxDto> {
        let url_ = this.baseUrl + "/sdsg/Rfx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editRfxRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_UpdateRfx(_response));
        });
    }

    protected processRfx_UpdateRfx(response: Response): Promise<RfxDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RfxDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the RfxID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RfxDto>(null as any);
    }

    /**
     * Delete the Rfx
     * @param requestId (optional) The Rfx id
     * @param suppressNotification (optional) To propogate events or not
     */
    rfx_Delete(requestId: string | null | undefined, suppressNotification: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Rfx?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (suppressNotification !== undefined && suppressNotification !== null)
            url_ += "suppressNotification=" + encodeURIComponent("" + suppressNotification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_Delete(_response));
        });
    }

    protected processRfx_Delete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get rfxs with pagination
     * @param pageNumber (optional) The page number
     * @param pageSize (optional) Page size
     */
    rfx_Rfxs(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfRfxDto> {
        let url_ = this.baseUrl + "/sdsg/Rfx?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_Rfxs(_response));
        });
    }

    protected processRfx_Rfxs(response: Response): Promise<PaginatedListOfRfxDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRfxDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRfxDto>(null as any);
    }

    /**
     * Get the Rfx by Id
     * @param rfxId The Guid
     * @return Returns the Rfx objec
     */
    rfx_GetRfxById(rfxId: string): Promise<RfxDto> {
        let url_ = this.baseUrl + "/sdsg/Rfx/{rfxId}";
        if (rfxId === undefined || rfxId === null)
            throw new Error("The parameter 'rfxId' must be defined.");
        url_ = url_.replace("{rfxId}", encodeURIComponent("" + rfxId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_GetRfxById(_response));
        });
    }

    protected processRfx_GetRfxById(response: Response): Promise<RfxDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RfxDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("There are any validation errors", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("When the RfxID is not found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RfxDto>(null as any);
    }

    /**
     * Assign user to the request
     * @return True on success
     */
    rfx_Assign(assignRequestDto: AssignRequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_Assign(_response));
        });
    }

    protected processRfx_Assign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reassign the Request
     */
    rfx_Reassign(reassignDto: RequestDto): Promise<void> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reassignDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_Reassign(_response));
        });
    }

    protected processRfx_Reassign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    rfx_DeleteCustomerImpact(id: string, customerImpact: CustomerImpactDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Rfx/{id}/DeleteCustomerImpact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_DeleteCustomerImpact(_response));
        });
    }

    protected processRfx_DeleteCustomerImpact(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    rfx_AddAttachments(addAttachmentDto: AddAttachmentDto): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addAttachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_AddAttachments(_response));
        });
    }

    protected processRfx_AddAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    rfx_DeleteAttachmentById(id: string, entityId: string | null | undefined, entityType: EntityType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Attachment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_DeleteAttachmentById(_response));
        });
    }

    protected processRfx_DeleteAttachmentById(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    rfx_GetAttachments(entityId: string | null | undefined, entityType: EntityType | undefined, portal: Portal | undefined): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Attachment/List?";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (portal === null)
            throw new Error("The parameter 'portal' cannot be null.");
        else if (portal !== undefined)
            url_ += "portal=" + encodeURIComponent("" + portal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_GetAttachments(_response));
        });
    }

    protected processRfx_GetAttachments(response: Response): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    /**
     * Update the classification of an attachment
     */
    rfx_UpdateClassification(attachmentDto: UpdateClassificationDto): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Attachment/UpdateClassification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_UpdateClassification(_response));
        });
    }

    protected processRfx_UpdateClassification(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    rfx_UpdateParentChild(requestDto: RequestDto): Promise<RequestDto> {
        let url_ = this.baseUrl + "/sdsg/Rfx/ParentChild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_UpdateParentChild(_response));
        });
    }

    protected processRfx_UpdateParentChild(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    rfx_UpdateDevices(requestDto: RequestDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_UpdateDevices(_response));
        });
    }

    protected processRfx_UpdateDevices(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Add Hash Tags
     * @param id SKP-ID
     * @param hashTags HashTags
     */
    rfx_AddHashTags(id: string, hashTags: HashTagDto[]): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Rfx/{id}/AddHashTags";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hashTags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_AddHashTags(_response));
        });
    }

    protected processRfx_AddHashTags(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    rfx_AddCustomerImpact(addCustomerImpact: AddCustomerImpactDto): Promise<CustomerImpactResponseDto> {
        let url_ = this.baseUrl + "/sdsg/Rfx/AddCustomerImpact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addCustomerImpact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_AddCustomerImpact(_response));
        });
    }

    protected processRfx_AddCustomerImpact(response: Response): Promise<CustomerImpactResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerImpactResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerImpactResponseDto>(null as any);
    }

    rfx_UpdateWatcher(addWatcherDto: AddWatcherDto): Promise<boolean> {
        let url_ = this.baseUrl + "/sdsg/Rfx/Watcher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addWatcherDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRfx_UpdateWatcher(_response));
        });
    }

    protected processRfx_UpdateWatcher(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class EnumLookUp implements IEnumLookUp {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEnumLookUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumLookUp {
        data = typeof data === 'object' ? data : {};
        let result = new EnumLookUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnumLookUp {
    id?: number;
    name?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class BaseRequestDto implements IBaseRequestDto {
    id?: string;
    whyThisDateIsImportant?: string | undefined;
    unifiedTrackingId?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    closedOn?: Date | undefined;
    description?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    watchers?: UserDto[] | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    totalDeviceCount?: number;
    totalRevenue?: number;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number;
    msxCurrentTotalDeviceCount?: number;
    reasonForReassignment?: number | undefined;
    assignee?: UserDto | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    isParent?: boolean | undefined;
    childrenCount?: number | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    originalRoutingML?: boolean | undefined;
    isActive?: boolean;

    constructor(data?: IBaseRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
            this.unifiedTrackingId = _data["unifiedTrackingId"];
            this.status = _data["status"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.actualResolutionDate = _data["actualResolutionDate"] ? new Date(_data["actualResolutionDate"].toString()) : <any>undefined;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["customerImpacts"])) {
                this.customerImpacts = [] as any;
                for (let item of _data["customerImpacts"])
                    this.customerImpacts!.push(CustomerImpactDto.fromJS(item));
            }
            if (Array.isArray(_data["watchers"])) {
                this.watchers = [] as any;
                for (let item of _data["watchers"])
                    this.watchers!.push(UserDto.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.totalDeviceCount = _data["totalDeviceCount"];
            this.totalRevenue = _data["totalRevenue"];
            this.msxTotalRevenue = _data["msxTotalRevenue"];
            this.msxTotalDeviceCount = _data["msxTotalDeviceCount"];
            this.msxCurrentTotalRevenue = _data["msxCurrentTotalRevenue"];
            this.msxCurrentTotalDeviceCount = _data["msxCurrentTotalDeviceCount"];
            this.reasonForReassignment = _data["reasonForReassignment"];
            this.assignee = _data["assignee"] ? UserDto.fromJS(_data["assignee"]) : <any>undefined;
            this.companyInformation = _data["companyInformation"] ? CompanyInformationDto.fromJS(_data["companyInformation"]) : <any>undefined;
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
            if (Array.isArray(_data["hashTags"])) {
                this.hashTags = [] as any;
                for (let item of _data["hashTags"])
                    this.hashTags!.push(HashTagDto.fromJS(item));
            }
            this.isParent = _data["isParent"];
            this.childrenCount = _data["childrenCount"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestDatabaseId = _data["parentRequestDatabaseId"];
            this.originalRoutingML = _data["originalRoutingML"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BaseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        data["unifiedTrackingId"] = this.unifiedTrackingId;
        data["status"] = this.status;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["actualResolutionDate"] = this.actualResolutionDate ? this.actualResolutionDate.toISOString() : <any>undefined;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.customerImpacts)) {
            data["customerImpacts"] = [];
            for (let item of this.customerImpacts)
                data["customerImpacts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.watchers)) {
            data["watchers"] = [];
            for (let item of this.watchers)
                data["watchers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["totalDeviceCount"] = this.totalDeviceCount;
        data["totalRevenue"] = this.totalRevenue;
        data["msxTotalRevenue"] = this.msxTotalRevenue;
        data["msxTotalDeviceCount"] = this.msxTotalDeviceCount;
        data["msxCurrentTotalRevenue"] = this.msxCurrentTotalRevenue;
        data["msxCurrentTotalDeviceCount"] = this.msxCurrentTotalDeviceCount;
        data["reasonForReassignment"] = this.reasonForReassignment;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["companyInformation"] = this.companyInformation ? this.companyInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hashTags)) {
            data["hashTags"] = [];
            for (let item of this.hashTags)
                data["hashTags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isParent"] = this.isParent;
        data["childrenCount"] = this.childrenCount;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestDatabaseId"] = this.parentRequestDatabaseId;
        data["originalRoutingML"] = this.originalRoutingML;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBaseRequestDto {
    id?: string;
    whyThisDateIsImportant?: string | undefined;
    unifiedTrackingId?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    closedOn?: Date | undefined;
    description?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    watchers?: UserDto[] | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    totalDeviceCount?: number;
    totalRevenue?: number;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number;
    msxCurrentTotalDeviceCount?: number;
    reasonForReassignment?: number | undefined;
    assignee?: UserDto | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    isParent?: boolean | undefined;
    childrenCount?: number | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    originalRoutingML?: boolean | undefined;
    isActive?: boolean;
}

export class CreateProposalDto extends BaseRequestDto implements ICreateProposalDto {
    summary?: string | undefined;
    industry?: IndustryDto | undefined;
    caseNumber?: string | undefined;
    primaryPartner?: string | undefined;

    constructor(data?: ICreateProposalDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.industry = _data["industry"] ? IndustryDto.fromJS(_data["industry"]) : <any>undefined;
            this.caseNumber = _data["caseNumber"];
            this.primaryPartner = _data["primaryPartner"];
        }
    }

    static override fromJS(data: any): CreateProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProposalDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        data["caseNumber"] = this.caseNumber;
        data["primaryPartner"] = this.primaryPartner;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateProposalDto extends IBaseRequestDto {
    summary?: string | undefined;
    industry?: IndustryDto | undefined;
    caseNumber?: string | undefined;
    primaryPartner?: string | undefined;
}

export class IndustryDto implements IIndustryDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIndustryDto {
    id?: number;
    name?: string | undefined;
}

export enum RequestStatus {
    New = 1,
    Active = 2,
    InProgress = 3,
    Resolved = 4,
    Closed = 5,
}

export class AttachmentDto implements IAttachmentDto {
    id?: string;
    url?: string | undefined;
    fileName?: string | undefined;
    blobFileName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    isExternal?: boolean;
    etag?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.blobFileName = _data["blobFileName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.isExternal = _data["isExternal"];
            this.etag = _data["etag"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["blobFileName"] = this.blobFileName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["isExternal"] = this.isExternal;
        data["etag"] = this.etag;
        return data;
    }
}

export interface IAttachmentDto {
    id?: string;
    url?: string | undefined;
    fileName?: string | undefined;
    blobFileName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    isExternal?: boolean;
    etag?: string | undefined;
}

export class UserDto implements IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.userDomain = _data["userDomain"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.contactNumber = _data["contactNumber"];
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["userDomain"] = this.userDomain;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["contactNumber"] = this.contactNumber;
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;
}

export enum RequestDomain {
    SDSG = 1,
    CXP = 2,
    CSS = 3,
    Crew = 4,
    Admin = 5,
}

export class UserRole implements IUserRole {
    roleName?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRole {
    roleName?: string | undefined;
}

export class CustomerImpactDto implements ICustomerImpactDto {
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    accountId?: string | undefined;
    customerName?: string | undefined;
    customerImpactDescription?: string | undefined;
    customerCountry?: CountryDto | undefined;
    msxOpportunityId?: string | undefined;
    deviceCount?: number | undefined;
    revenue?: number | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    addedOn?: Date;
    addedBy?: UserDto | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: ICustomerImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.tpId = _data["tpId"];
            this.accountId = _data["accountId"];
            this.customerName = _data["customerName"];
            this.customerImpactDescription = _data["customerImpactDescription"];
            this.customerCountry = _data["customerCountry"] ? CountryDto.fromJS(_data["customerCountry"]) : <any>undefined;
            this.msxOpportunityId = _data["msxOpportunityId"];
            this.deviceCount = _data["deviceCount"];
            this.revenue = _data["revenue"];
            this.msxDeviceCount = _data["msxDeviceCount"];
            this.msxRevenue = _data["msxRevenue"];
            this.msxCurrentDeviceCount = _data["msxCurrentDeviceCount"];
            this.msxCurrentRevenue = _data["msxCurrentRevenue"];
            this.msxInfoUpdatedOn = _data["msxInfoUpdatedOn"] ? new Date(_data["msxInfoUpdatedOn"].toString()) : <any>undefined;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
            this.addedBy = _data["addedBy"] ? UserDto.fromJS(_data["addedBy"]) : <any>undefined;
            this.endCustomerSegment = _data["endCustomerSegment"];
            this.competitor = _data["competitor"];
            this.salesPlay = _data["salesPlay"];
            this.refreshYourDevice = _data["refreshYourDevice"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): CustomerImpactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["tpId"] = this.tpId;
        data["accountId"] = this.accountId;
        data["customerName"] = this.customerName;
        data["customerImpactDescription"] = this.customerImpactDescription;
        data["customerCountry"] = this.customerCountry ? this.customerCountry.toJSON() : <any>undefined;
        data["msxOpportunityId"] = this.msxOpportunityId;
        data["deviceCount"] = this.deviceCount;
        data["revenue"] = this.revenue;
        data["msxDeviceCount"] = this.msxDeviceCount;
        data["msxRevenue"] = this.msxRevenue;
        data["msxCurrentDeviceCount"] = this.msxCurrentDeviceCount;
        data["msxCurrentRevenue"] = this.msxCurrentRevenue;
        data["msxInfoUpdatedOn"] = this.msxInfoUpdatedOn ? this.msxInfoUpdatedOn.toISOString() : <any>undefined;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : <any>undefined;
        data["endCustomerSegment"] = this.endCustomerSegment;
        data["competitor"] = this.competitor;
        data["salesPlay"] = this.salesPlay;
        data["refreshYourDevice"] = this.refreshYourDevice;
        data["status"] = this.status;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface ICustomerImpactDto {
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    accountId?: string | undefined;
    customerName?: string | undefined;
    customerImpactDescription?: string | undefined;
    customerCountry?: CountryDto | undefined;
    msxOpportunityId?: string | undefined;
    deviceCount?: number | undefined;
    revenue?: number | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    addedOn?: Date;
    addedBy?: UserDto | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export class CountryDto implements ICountryDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryDto {
    id?: number;
    name?: string | undefined;
}

export class CompanyInformationDto implements ICompanyInformationDto {
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    alternateContactNumber?: string | undefined;

    constructor(data?: ICompanyInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRegion = _data["companyRegion"];
            this.companyContactName = _data["companyContactName"];
            this.companyFullShippingAddress = _data["companyFullShippingAddress"];
            this.companyName = _data["companyName"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.country = _data["country"];
            this.alternateContactNumber = _data["alternateContactNumber"];
        }
    }

    static fromJS(data: any): CompanyInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegion"] = this.companyRegion;
        data["companyContactName"] = this.companyContactName;
        data["companyFullShippingAddress"] = this.companyFullShippingAddress;
        data["companyName"] = this.companyName;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["country"] = this.country;
        data["alternateContactNumber"] = this.alternateContactNumber;
        return data;
    }
}

export interface ICompanyInformationDto {
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    alternateContactNumber?: string | undefined;
}

export enum CompanyRegion {
    AOC = 1,
    EMEA = 2,
    APAC = 3,
    LATAM = 4,
    Global = 5,
}

export class DeviceModelDto implements IDeviceModelDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    count?: number | undefined;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;

    constructor(data?: IDeviceModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.deviceCount = _data["deviceCount"];
            this.count = _data["count"];
            this.iconUrl = _data["iconUrl"];
            this.isAdded = _data["isAdded"];
        }
    }

    static fromJS(data: any): DeviceModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["deviceCount"] = this.deviceCount;
        data["count"] = this.count;
        data["iconUrl"] = this.iconUrl;
        data["isAdded"] = this.isAdded;
        return data;
    }
}

export interface IDeviceModelDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    count?: number | undefined;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;
}

export class HashTagDto implements IHashTagDto {
    hashTag?: string | undefined;

    constructor(data?: IHashTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashTag = _data["hashTag"];
        }
    }

    static fromJS(data: any): HashTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new HashTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashTag"] = this.hashTag;
        return data;
    }
}

export interface IHashTagDto {
    hashTag?: string | undefined;
}

export class ProposalDto extends CreateProposalDto implements IProposalDto {
    productCategory?: ProductCategory | undefined;

    constructor(data?: IProposalDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
        }
    }

    static override fromJS(data: any): ProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        super.toJSON(data);
        return data;
    }
}

export interface IProposalDto extends ICreateProposalDto {
    productCategory?: ProductCategory | undefined;
}

export enum ProductCategory {
    Hardware = 1,
    Software = 2,
    Other = 3,
    Expirience = 4,
    Policy = 5,
    Warranty = 6,
    ProductFamily = 7,
}

export class EditRequestDto implements IEditRequestDto {
    id?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    closedOn?: Date | undefined;
    actualResolutionDate?: Date | undefined;

    constructor(data?: IEditRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.companyInformation = _data["companyInformation"] ? CompanyInformationDto.fromJS(_data["companyInformation"]) : <any>undefined;
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
            if (Array.isArray(_data["hashTags"])) {
                this.hashTags = [] as any;
                for (let item of _data["hashTags"])
                    this.hashTags!.push(HashTagDto.fromJS(item));
            }
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.actualResolutionDate = _data["actualResolutionDate"] ? new Date(_data["actualResolutionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EditRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["status"] = this.status;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["companyInformation"] = this.companyInformation ? this.companyInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hashTags)) {
            data["hashTags"] = [];
            for (let item of this.hashTags)
                data["hashTags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["actualResolutionDate"] = this.actualResolutionDate ? this.actualResolutionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEditRequestDto {
    id?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    closedOn?: Date | undefined;
    actualResolutionDate?: Date | undefined;
}

export class EditProposalDto extends EditRequestDto implements IEditProposalDto {
    productCategory?: ProductCategory | undefined;
    whyThisDateIsImportant?: string | undefined;

    constructor(data?: IEditProposalDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
        }
    }

    static override fromJS(data: any): EditProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditProposalDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        super.toJSON(data);
        return data;
    }
}

export interface IEditProposalDto extends IEditRequestDto {
    productCategory?: ProductCategory | undefined;
    whyThisDateIsImportant?: string | undefined;
}

export class PaginatedListOfProposalDto implements IPaginatedListOfProposalDto {
    items?: ProposalDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProposalDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfProposalDto {
    items?: ProposalDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AssignRequestDto implements IAssignRequestDto {
    id?: string | undefined;
    assignee?: UserDto | undefined;
    ccUsers?: UserDto[] | undefined;
    assigneeNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IAssignRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignee = _data["assignee"] ? UserDto.fromJS(_data["assignee"]) : <any>undefined;
            if (Array.isArray(_data["ccUsers"])) {
                this.ccUsers = [] as any;
                for (let item of _data["ccUsers"])
                    this.ccUsers!.push(UserDto.fromJS(item));
            }
            this.assigneeNote = _data["assigneeNote"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        if (Array.isArray(this.ccUsers)) {
            data["ccUsers"] = [];
            for (let item of this.ccUsers)
                data["ccUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["assigneeNote"] = this.assigneeNote;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAssignRequestDto {
    id?: string | undefined;
    assignee?: UserDto | undefined;
    ccUsers?: UserDto[] | undefined;
    assigneeNote?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class RequestDto extends BaseRequestDto implements IRequestDto {
    summary?: string | undefined;
    isHidden?: boolean;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    customerType?: CrewCustomerType | undefined;
    actionRequired?: string | undefined;
    additionalContact?: AdditionalContactDto | undefined;
    requestActionTakenByCss?: string | undefined;
    isDcfRequest?: boolean | undefined;
    dcfJustification?: string | undefined;
    dealInfluenced?: boolean | undefined;
    closingSummary?: string | undefined;
    cssCaseNumber?: string | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    serialNumbersAttached?: boolean | undefined;
    isBookmarked?: boolean;
    priorityNumber?: number | undefined;
    criticality?: Criticality | undefined;
    impactReach?: ImpactReach | undefined;
    productCategory?: ProductCategory | undefined;
    approvedMessaging?: string | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    competitiveOffering?: string | undefined;
    isDesignForSurfacedPossible?: string | undefined;
    pfrSubType?: PFRSubtype | undefined;
    bugInformations?: BugInformations[] | undefined;
    bugNumber?: string | undefined;
    priority?: Priority | undefined;
    caseCodeInvestigation?: CaseCodeInvestigation | undefined;
    caseCodeRequest?: CaseCodeRequest | undefined;
    mainRequestType?: MainRequestType | undefined;
    subRequestType?: SubRequestType | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    dcfApprovedValue?: number | undefined;
    dcfSR?: string | undefined;
    answer?: string | undefined;
    backendId?: string | undefined;
    backendUrl?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    tags?: TagDto[] | undefined;
    selected?: any | undefined;

    constructor(data?: IRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.isHidden = _data["isHidden"];
            this.requestType = _data["requestType"];
            this.requestTeam = _data["requestTeam"];
            this.customerType = _data["customerType"];
            this.actionRequired = _data["actionRequired"];
            this.additionalContact = _data["additionalContact"] ? AdditionalContactDto.fromJS(_data["additionalContact"]) : <any>undefined;
            this.requestActionTakenByCss = _data["requestActionTakenByCss"];
            this.isDcfRequest = _data["isDcfRequest"];
            this.dcfJustification = _data["dcfJustification"];
            this.dealInfluenced = _data["dealInfluenced"];
            this.closingSummary = _data["closingSummary"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.proofOfPurchaseAttached = _data["proofOfPurchaseAttached"];
            this.serialNumbersAttached = _data["serialNumbersAttached"];
            this.isBookmarked = _data["isBookmarked"];
            this.priorityNumber = _data["priorityNumber"];
            this.criticality = _data["criticality"];
            this.impactReach = _data["impactReach"];
            this.productCategory = _data["productCategory"];
            this.approvedMessaging = _data["approvedMessaging"];
            this.whatBusinessProblemIsSolved = _data["whatBusinessProblemIsSolved"];
            this.competitiveOffering = _data["competitiveOffering"];
            this.isDesignForSurfacedPossible = _data["isDesignForSurfacedPossible"];
            this.pfrSubType = _data["pfrSubType"];
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformations.fromJS(item));
            }
            this.bugNumber = _data["bugNumber"];
            this.priority = _data["priority"];
            this.caseCodeInvestigation = _data["caseCodeInvestigation"];
            this.caseCodeRequest = _data["caseCodeRequest"];
            this.mainRequestType = _data["mainRequestType"];
            this.subRequestType = _data["subRequestType"];
            this.isBlockingSale = _data["isBlockingSale"];
            this.isDcfApproved = _data["isDcfApproved"];
            this.dcfApprovedValue = _data["dcfApprovedValue"];
            this.dcfSR = _data["dcfSR"];
            this.answer = _data["answer"];
            this.backendId = _data["backendId"];
            this.backendUrl = _data["backendUrl"];
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static override fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["isHidden"] = this.isHidden;
        data["requestType"] = this.requestType;
        data["requestTeam"] = this.requestTeam;
        data["customerType"] = this.customerType;
        data["actionRequired"] = this.actionRequired;
        data["additionalContact"] = this.additionalContact ? this.additionalContact.toJSON() : <any>undefined;
        data["requestActionTakenByCss"] = this.requestActionTakenByCss;
        data["isDcfRequest"] = this.isDcfRequest;
        data["dcfJustification"] = this.dcfJustification;
        data["dealInfluenced"] = this.dealInfluenced;
        data["closingSummary"] = this.closingSummary;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["proofOfPurchaseAttached"] = this.proofOfPurchaseAttached;
        data["serialNumbersAttached"] = this.serialNumbersAttached;
        data["isBookmarked"] = this.isBookmarked;
        data["priorityNumber"] = this.priorityNumber;
        data["criticality"] = this.criticality;
        data["impactReach"] = this.impactReach;
        data["productCategory"] = this.productCategory;
        data["approvedMessaging"] = this.approvedMessaging;
        data["whatBusinessProblemIsSolved"] = this.whatBusinessProblemIsSolved;
        data["competitiveOffering"] = this.competitiveOffering;
        data["isDesignForSurfacedPossible"] = this.isDesignForSurfacedPossible;
        data["pfrSubType"] = this.pfrSubType;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["bugNumber"] = this.bugNumber;
        data["priority"] = this.priority;
        data["caseCodeInvestigation"] = this.caseCodeInvestigation;
        data["caseCodeRequest"] = this.caseCodeRequest;
        data["mainRequestType"] = this.mainRequestType;
        data["subRequestType"] = this.subRequestType;
        data["isBlockingSale"] = this.isBlockingSale;
        data["isDcfApproved"] = this.isDcfApproved;
        data["dcfApprovedValue"] = this.dcfApprovedValue;
        data["dcfSR"] = this.dcfSR;
        data["answer"] = this.answer;
        data["backendId"] = this.backendId;
        data["backendUrl"] = this.backendUrl;
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["selected"] = this.selected;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestDto extends IBaseRequestDto {
    summary?: string | undefined;
    isHidden?: boolean;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    customerType?: CrewCustomerType | undefined;
    actionRequired?: string | undefined;
    additionalContact?: AdditionalContactDto | undefined;
    requestActionTakenByCss?: string | undefined;
    isDcfRequest?: boolean | undefined;
    dcfJustification?: string | undefined;
    dealInfluenced?: boolean | undefined;
    closingSummary?: string | undefined;
    cssCaseNumber?: string | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    serialNumbersAttached?: boolean | undefined;
    isBookmarked?: boolean;
    priorityNumber?: number | undefined;
    criticality?: Criticality | undefined;
    impactReach?: ImpactReach | undefined;
    productCategory?: ProductCategory | undefined;
    approvedMessaging?: string | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    competitiveOffering?: string | undefined;
    isDesignForSurfacedPossible?: string | undefined;
    pfrSubType?: PFRSubtype | undefined;
    bugInformations?: BugInformations[] | undefined;
    bugNumber?: string | undefined;
    priority?: Priority | undefined;
    caseCodeInvestigation?: CaseCodeInvestigation | undefined;
    caseCodeRequest?: CaseCodeRequest | undefined;
    mainRequestType?: MainRequestType | undefined;
    subRequestType?: SubRequestType | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    dcfApprovedValue?: number | undefined;
    dcfSR?: string | undefined;
    answer?: string | undefined;
    backendId?: string | undefined;
    backendUrl?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    tags?: TagDto[] | undefined;
    selected?: any | undefined;
}

export enum RequestType {
    Proposal = 1,
    Question = 2,
    Rfx = 3,
    PreSales = 4,
    PostSales = 5,
    CSSRequest = 6,
    CssReviewRequest = 7,
    CXP_VariantRequest = 8,
    CXP_PFR_Request = 9,
    CXP_MessagingRequest = 10,
    CXP_TechnicalRequest = 11,
    CXP_ProgramRequest = 12,
    CREW_WarrantyRequest = 13,
    CREW_ProductRequest = 14,
    CREW_MessagingRequest = 15,
}

export enum CrewCustomerType {
    Business_Enterprise_Customer = 1,
    EDU_Customer = 2,
    GOV_Customer = 3,
}

export class AdditionalContactDto implements IAdditionalContactDto {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;

    constructor(data?: IAdditionalContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalShippingAddress = _data["additionalShippingAddress"];
            this.additionalEmailAddress = _data["additionalEmailAddress"];
            this.additionalPhoneNumber = _data["additionalPhoneNumber"];
        }
    }

    static fromJS(data: any): AdditionalContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalShippingAddress"] = this.additionalShippingAddress;
        data["additionalEmailAddress"] = this.additionalEmailAddress;
        data["additionalPhoneNumber"] = this.additionalPhoneNumber;
        return data;
    }
}

export interface IAdditionalContactDto {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;
}

export enum Criticality {
    Zero = 1,
    Fifty = 2,
    OneHundred = 3,
    TwoHundred = 4,
}

export enum ImpactReach {
    Exec_CAB = 1,
    Global = 2,
    No = 3,
}

export enum PFRSubtype {
    Emerging_PFR = 1,
    Priority_PFR = 2,
}

export class BugInformations implements IBugInformations {
    bugInformation?: BugInformation;
    url?: string | undefined;

    constructor(data?: IBugInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bugInformation = _data["bugInformation"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BugInformations {
        data = typeof data === 'object' ? data : {};
        let result = new BugInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bugInformation"] = this.bugInformation;
        data["url"] = this.url;
        return data;
    }
}

export interface IBugInformations {
    bugInformation?: BugInformation;
    url?: string | undefined;
}

export enum BugInformation {
    PLE_Bug = 1,
    MSFT_Devices_Non_PLE_Bug = 2,
    OS_Bug = 3,
    Hub_OS_Bug = 4,
    Other_Bugs = 5,
    Azure_Devops_Link = 6,
}

export enum Priority {
    High = 1,
    Medium = 2,
    Low = 3,
}

export enum CaseCodeInvestigation {
    CoverageDetails = 1,
    FeedbackSuggestion = 2,
    Operational_SLA = 3,
    Process_Or_PolicyFailure_Limitation = 4,
    Proper_Process_Not_Followed = 5,
    ReverseLogistics = 6,
    RRT_Scenario = 7,
    Surface_Help_Request = 8,
}

export enum CaseCodeRequest {
    FortyFiveDayException = 1,
    ASKU = 2,
    BulkOrder_Or_Exchange = 3,
    DOA_Exception = 4,
    DocumentationRequest = 5,
    GeneralException = 6,
    InvoiceDispute = 7,
    Missing_ADP_Or_EHS = 8,
    NotAvailable = 9,
    Other = 10,
    ProductQuality_Or_PLE = 11,
    ScreenFlicker = 12,
    SwollenBattery = 13,
    WA_Date_Correction = 14,
    WA_Deployment_Date_Adjustment = 15,
    WarrantyReport = 16,
    WrongAutoPilot_Or_InTuneRegistration = 17,
    ExchangeHistory = 18,
}

export enum MainRequestType {
    Exceptions = 1,
    Experience_Or_Offers = 2,
    Reporting = 3,
    Process_Or_PolicyFailure = 4,
    Process_Not_Followed = 5,
    Other = 6,
}

export enum SubRequestType {
    FortyFiveDayException = 1,
    ASKURequest = 2,
    BulkOrder_Or_ExchangeRequest = 3,
    BulkShipping_Or_PickUp = 4,
    OutOfWarranty = 5,
    SwollenBattery = 6,
    DCFGeneralRequest = 7,
    WA_DeploymentDateRequest = 8,
    EPP_PricingChange = 9,
    New_EPP_OfferType = 10,
    NewSupportExperiences = 11,
    OfferExpansion_NewMarket = 12,
    ExchangeHistory = 13,
    WarrantyStatusReport = 14,
    InvoiceDispute = 15,
    Missing_EPP_AfterExchange = 16,
    MissingShippingLabel = 17,
    WA_DateCorrection = 18,
    EPP_didnot_attach_via_MSOnline = 19,
    EPP_didnot_attach_via_MSBnM = 20,
    WA_DateDelay = 21,
    EPP_didnot_attach_OtherRetailer = 22,
    Partner_Didnot_Register = 23,
    ReturnWrongUnit = 24,
    Unit_Not_Returned = 25,
    Other = 26,
}

export enum TaskStatus {
    Consumer = 1,
    Duplicate = 2,
    Following_Or_NoAction = 3,
    FrontlineSupport = 4,
    FrontlineSupport_T2 = 5,
    InvalidRequest = 6,
    NonTechnical = 7,
    SEE_Takeover = 8,
}

export class TagDto implements ITagDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    id?: string;
    name?: string | undefined;
}

export class AddAttachmentDto implements IAddAttachmentDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IAddAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAddAttachmentDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    attachments?: AttachmentDto[] | undefined;
}

export enum EntityType {
    HelpRequest = 1,
    Feedback = 2,
    Article = 3,
    Comment = 4,
    Report = 5,
    Status = 6,
}

export enum Portal {
    User = 1,
    Admin = 2,
}

export class CustomerImpactResponseDto implements ICustomerImpactResponseDto {
    id?: string | undefined;

    constructor(data?: ICustomerImpactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerImpactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomerImpactResponseDto {
    id?: string | undefined;
}

export class AddCustomerImpactDto implements IAddCustomerImpactDto {
    requestId?: string | undefined;
    cssCaseNumber?: string | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    deviceModels?: DeviceModelDto[] | undefined;

    constructor(data?: IAddCustomerImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            if (Array.isArray(_data["customerImpacts"])) {
                this.customerImpacts = [] as any;
                for (let item of _data["customerImpacts"])
                    this.customerImpacts!.push(CustomerImpactDto.fromJS(item));
            }
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddCustomerImpactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerImpactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["cssCaseNumber"] = this.cssCaseNumber;
        if (Array.isArray(this.customerImpacts)) {
            data["customerImpacts"] = [];
            for (let item of this.customerImpacts)
                data["customerImpacts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAddCustomerImpactDto {
    requestId?: string | undefined;
    cssCaseNumber?: string | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
}

export class AddWatcherDto implements IAddWatcherDto {
    users?: UserDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    requestId?: string | undefined;

    constructor(data?: IAddWatcherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): AddWatcherDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddWatcherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IAddWatcherDto {
    users?: UserDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    requestId?: string | undefined;
}

export class CreateQuestionDto extends BaseRequestDto implements ICreateQuestionDto {
    questionText?: string | undefined;
    answer?: string | undefined;
    industry?: IndustryDto | undefined;
    caseNumber?: string | undefined;
    primaryPartner?: string | undefined;

    constructor(data?: ICreateQuestionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionText = _data["questionText"];
            this.answer = _data["answer"];
            this.industry = _data["industry"] ? IndustryDto.fromJS(_data["industry"]) : <any>undefined;
            this.caseNumber = _data["caseNumber"];
            this.primaryPartner = _data["primaryPartner"];
        }
    }

    static override fromJS(data: any): CreateQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["answer"] = this.answer;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        data["caseNumber"] = this.caseNumber;
        data["primaryPartner"] = this.primaryPartner;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateQuestionDto extends IBaseRequestDto {
    questionText?: string | undefined;
    answer?: string | undefined;
    industry?: IndustryDto | undefined;
    caseNumber?: string | undefined;
    primaryPartner?: string | undefined;
}

export class QuestionDto extends CreateQuestionDto implements IQuestionDto {
    productCategory?: ProductCategory | undefined;

    constructor(data?: IQuestionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
        }
    }

    static override fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        super.toJSON(data);
        return data;
    }
}

export interface IQuestionDto extends ICreateQuestionDto {
    productCategory?: ProductCategory | undefined;
}

export class EditQuestionDto extends EditRequestDto implements IEditQuestionDto {
    productCategory?: ProductCategory | undefined;
    answer?: string | undefined;
    whyThisDateIsImportant?: string | undefined;

    constructor(data?: IEditQuestionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
            this.answer = _data["answer"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
        }
    }

    static override fromJS(data: any): EditQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        data["answer"] = this.answer;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        super.toJSON(data);
        return data;
    }
}

export interface IEditQuestionDto extends IEditRequestDto {
    productCategory?: ProductCategory | undefined;
    answer?: string | undefined;
    whyThisDateIsImportant?: string | undefined;
}

export class PaginatedListOfQuestionDto implements IPaginatedListOfQuestionDto {
    items?: QuestionDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfQuestionDto {
    items?: QuestionDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class UpdateClassificationDto implements IUpdateClassificationDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    id?: string;

    constructor(data?: IUpdateClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateClassificationDto {
    entityId?: string | undefined;
    entityType?: EntityType;
    id?: string;
}

export class CreateRfxDto extends BaseRequestDto implements ICreateRfxDto {
    summary?: string | undefined;
    industry?: IndustryDto | undefined;
    caseNumber?: string | undefined;
    primaryPartner?: string | undefined;

    constructor(data?: ICreateRfxDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.industry = _data["industry"] ? IndustryDto.fromJS(_data["industry"]) : <any>undefined;
            this.caseNumber = _data["caseNumber"];
            this.primaryPartner = _data["primaryPartner"];
        }
    }

    static override fromJS(data: any): CreateRfxDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRfxDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        data["caseNumber"] = this.caseNumber;
        data["primaryPartner"] = this.primaryPartner;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRfxDto extends IBaseRequestDto {
    summary?: string | undefined;
    industry?: IndustryDto | undefined;
    caseNumber?: string | undefined;
    primaryPartner?: string | undefined;
}

export class RfxDto extends CreateRfxDto implements IRfxDto {
    productCategory?: ProductCategory | undefined;

    constructor(data?: IRfxDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
        }
    }

    static override fromJS(data: any): RfxDto {
        data = typeof data === 'object' ? data : {};
        let result = new RfxDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        super.toJSON(data);
        return data;
    }
}

export interface IRfxDto extends ICreateRfxDto {
    productCategory?: ProductCategory | undefined;
}

export class EditRfxDto extends EditRequestDto implements IEditRfxDto {
    productCategory?: ProductCategory | undefined;
    whyThisDateIsImportant?: string | undefined;

    constructor(data?: IEditRfxDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCategory = _data["productCategory"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
        }
    }

    static override fromJS(data: any): EditRfxDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditRfxDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        super.toJSON(data);
        return data;
    }
}

export interface IEditRfxDto extends IEditRequestDto {
    productCategory?: ProductCategory | undefined;
    whyThisDateIsImportant?: string | undefined;
}

export class PaginatedListOfRfxDto implements IPaginatedListOfRfxDto {
    items?: RfxDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfRfxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RfxDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfRfxDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfRfxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfRfxDto {
    items?: RfxDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    UnprocessableContent = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export class SdsgApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSdsgApiException = true;

    static isSdsgApiException(obj: any): obj is SdsgApiException {
        return obj.isSdsgApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SdsgApiException(message, status, response, headers, null);
}

// Adds Authorization header to requests made by the nswag generated clients

export class ApiError extends Error {
    status: number;
    statusText: string;
    detail: any;

    constructor(status: number, statusText: string, detail?: any) {
        super(`${status} ${statusText}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.detail = detail;
    }

    static isApiError(obj: any): obj is ApiError {
        return obj instanceof ApiError;
    }
}